// extracted by mini-css-extract-plugin
export default {"linkMobile":"phoneNumber-module--linkMobile--Sh5Za","telDesktop":"phoneNumber-module--telDesktop--Aa0ar"};